import { autoCapitalize } from '@/utils/autoCapitalize'
import {
  PermissionsDetailsResponse,
  UserDetails,
} from '../../ConexaAdminServices/ConexaAdminServices.types'

class ConexaAdminUserDetailsMapper {
  toDomain(persistenceData: PermissionsDetailsResponse): UserDetails {
    return {
      id: persistenceData?.id,
      email: persistenceData?.email?.toLowerCase(),
      name: autoCapitalize(persistenceData?.nome),
      permissions: persistenceData?.permissoesBackofficeAcoes?.permissoes,
      actions: persistenceData?.permissoesBackofficeAcoes?.acoes?.map(
        item => item?.id,
      ),
      actionsDescriptions:
        persistenceData?.permissoesBackofficeAcoes?.acoes?.map(
          item => item?.descricao,
        ),
    }
  }
}

export default new ConexaAdminUserDetailsMapper()
